import React, { useEffect, useState } from "react";
import { Heart } from "phosphor-react";
import "./wishlisticon.css";
import { batch, useDispatch, useSelector } from "react-redux";
import {
  addProductToWishlist,
  getWishlistProducts,
} from "../../appState/slices/wishlist/wishlistSlice";
import { setToastMessage } from "../../appState/slices/util/utilSlice";
import { getFilterProducts, getProductList } from "../../appState/slices/product/productSlice";
import { useParams } from "react-router-dom";
import { changeFlag } from "../../appState/slices/auth/authSlice";
const WishListIcon = ({ pagename, size, id, isWishlist }) => {
  const [selected, setSelected] = useState(isWishlist);
  const [isHoveredHeart, setIsHoveredHeart] = useState(false);
   const selectedsizes = useSelector(state => state.auth.category.selectedsizes);
      const selectedcolors = useSelector((state) => state.auth.category.selectedcolors);
      const sortby = useSelector((state) => state.auth.category.sortby);
          const selectedsubcategory = useSelector(state => state.auth.category.subcategory);
          const minValue = useSelector(state => state.auth.category.minValue);
          const maxValue = useSelector(state => state.auth.category.maxValue);
  if (pagename === "wishlist") {
    if (selected != isWishlist) {
      setSelected(isWishlist);
    }
  }
      const params = useParams();
  
  const { gender: gender } = params;
    const { category: categoryName } = params;
    const { subcategory: subCategoryName } = params;

  useEffect(() => {
    setSelected(isWishlist);
  }, [isWishlist]);

  const dispatch = useDispatch();
  const handleMouseEnter = () => {
    setIsHoveredHeart(true);
  };
  const handleMouseLeave = () => {
    setIsHoveredHeart(false);
  };

  return (
    <div
      onClick={() => {
        batch(async () => {
          await dispatch(addProductToWishlist(id));
          await dispatch(changeFlag());
          await dispatch(getFilterProducts(
            {
               gender: gender,
               isActive : true,
                category: subCategoryName,
                sizes: selectedsizes,
                colors: selectedcolors,
                minPrice: minValue,
                maxPrice: maxValue,
                sortBy: sortby
            }
          ));
        });
        setSelected(!selected);
        if (selected) {

          dispatch(
            setToastMessage({
              type: "success",
              message: "Product removed successfully",
              show: true,
            })
          );
        } else {
          dispatch(
            setToastMessage({
              type: "success",
              message: "Product added successfully",
              show: true,
            })
          );
        }
      }}
      // className={`${
      //   pagename === "productlist" || pagename === "wishlist"
      //     ? "cardheart-productlist"
      //     : "cardheart-singleproduct"
      // }  ${
      //   isHoveredHeart || selected ? "redfillheart" : "blackborderheart"
      //   // ? "dynamicborderheart"
      //   // : "blackborderheart"
      // }`}
      className={`${
        pagename === "productlist" || pagename === "wishlist"
          ? "cardheart-productlist"
          : "cardheart-singleproduct"
      }  ${
        isHoveredHeart || selected
          ? "redfillheart"
          : pagename === "productlist"
          ? "dynamicborderheart"
          : "blackborderheart"
      }`}
      onMouseEnter={() => handleMouseEnter("heart")}
      onMouseLeave={() => handleMouseLeave("heart")}
    >
      <Heart
        size={size ? size : 20}
        weight={selected || isHoveredHeart ? "fill" : null}
      />
    </div>
  );
};

export default WishListIcon;
